import React from "react"

import CCMAdminPatient from "./CCMAdminPatient/CCMAdminPatient"

const CCMAdminComponent = () => <CCMAdminPatient isFromAddPatient />

export default CCMAdminComponent
